export const SCREENSIZES = {
  MOBILE: 480,
  TABLET: 600,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1200,
};
